import { Table, Typography } from "antd"
import { Link } from "react-router-dom"
import type { PointRevision } from "../../../types/regulatory"
import { NatureTag, PointDetails } from "./CatalogUI"
export function PointTable({ points }: { points: PointRevision[] }) {
  return (
    <Table<PointRevision>
      rowKey="uuid"
      dataSource={points}
      size="small"
      pagination={false}
      scroll={{ x: 650 }}
      columns={[
        { title: "Ordre", width: 70, render: (_value, _point, index) => index + 1 },
        { title: "Section", render: (_value, point) => point.definition.section },
        {
          title: "Point de contrôle",
          render: (_value, point) => (
            <>
              <Link to={`/regulatory/points/${point.uuid}`}>{point.definition.label}</Link>
              {point.definition.controlCode && (
                <Typography.Text type="secondary" style={{ display: "block" }}>
                  {point.definition.controlCode}
                </Typography.Text>
              )}
            </>
          ),
        },
        { title: "Nature", render: (_value, point) => <NatureTag point={point.definition} /> },
      ]}
      expandable={{ expandedRowRender: (point) => <PointDetails point={point} /> }}
    />
  )
}
